var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "borderlinestyle" },
    [
      _c("h2", [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _c(
        "el-form",
        { attrs: { "label-width": "80px", model: _vm.datas, size: "small" } },
        [
          _c(
            "el-form-item",
            { staticClass: "lef", attrs: { label: "空白高度" } },
            [
              _c("el-input-number", {
                attrs: { min: 0, size: "mini" },
                model: {
                  value: _vm.datas.blankHeight,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "blankHeight", $$v)
                  },
                  expression: "datas.blankHeight",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticStyle: { height: "20px" } }),
          _vm._v(" "),
          _c(
            "el-form-item",
            { staticClass: "lef", attrs: { label: "分割类型" } },
            [
              _c(
                "div",
                { staticClass: "weiz" },
                _vm._l(2, function (index) {
                  return _c(
                    "el-tooltip",
                    {
                      key: index,
                      attrs: {
                        effect: "dark",
                        content: index - 1 === 0 ? "辅助空白" : "辅助线",
                        placement: "bottom",
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "zdy-icon",
                        class: [
                          index - 1 === 0
                            ? "icon-border-line-blank"
                            : "icon-border-line-subline",
                          _vm.datas.borderType === index - 1 ? "active" : "",
                        ],
                        on: {
                          click: function ($event) {
                            _vm.datas.borderType = index - 1
                          },
                        },
                      }),
                    ]
                  )
                }),
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticStyle: { height: "20px" } }),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.datas.borderType === 1,
                  expression: "datas.borderType === 1",
                },
              ],
              staticClass: "lef",
              attrs: { label: "选择样式" },
            },
            [
              _c(
                "div",
                { staticClass: "weiz" },
                _vm._l(_vm.borderType, function (item, index) {
                  return _c(
                    "el-tooltip",
                    {
                      key: index,
                      attrs: {
                        effect: "dark",
                        content: item.text,
                        placement: "bottom",
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "zdy-icon",
                        class: [
                          item.icon,
                          _vm.datas.borderLineType === item.type
                            ? "active"
                            : "",
                        ],
                        on: {
                          click: function ($event) {
                            _vm.datas.borderLineType = item.type
                          },
                        },
                      }),
                    ]
                  )
                }),
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.datas.borderType === 1,
                expression: "datas.borderType === 1",
              },
            ],
            staticStyle: { height: "20px" },
          }),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.datas.borderType === 1,
                  expression: "datas.borderType === 1",
                },
              ],
              staticClass: "lef",
              attrs: { label: "左右边距" },
            },
            [
              _c("el-slider", {
                attrs: {
                  max: 100,
                  min: 0,
                  "input-size": "mini",
                  "show-input": "",
                },
                model: {
                  value: _vm.datas.margin,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "margin", $$v)
                  },
                  expression: "datas.margin",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.datas.borderType === 1,
                expression: "datas.borderType === 1",
              },
            ],
            staticStyle: { height: "20px" },
          }),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.datas.borderType === 1,
                  expression: "datas.borderType === 1",
                },
              ],
              staticClass: "lef aa",
              attrs: { label: "辅助线颜色" },
            },
            [
              _c("el-color-picker", {
                staticClass: "picke",
                attrs: { "show-alpha": "", predefine: _vm.predefineColors },
                model: {
                  value: _vm.datas.borderColor,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "borderColor", $$v)
                  },
                  expression: "datas.borderColor",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }